async function convertImageToBase64(url: string): Promise<string> {
  try {
    const response = await fetch(url, {
      method: "GET",
      mode: "cors", // explicitly request CORS mode
      cache: "no-cache", // bypass cached non-CORS response
    });

    if (!response.ok) throw new Error(`HTTP error: ${response.status}`);

    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.error("Image conversion failed:", err);
    throw err;
  }
}

export default convertImageToBase64;
